/**
 * RegressionCallout — amber pill below the Performance multi-line chart.
 *
 * Shows server-detected regressions: `Sentinel avg jumped from 1.18s →
 * 1.66s on 22 apr. Likely culprit: detect step.` plus an `Open trace`
 * deeplink to Timeline filtered by service+date.
 *
 * Props:
 *   service:      'merovingian' | 'sati' | 'sentinel' | 'seraph' | 'archivist'
 *   fromSeconds:  number
 *   toSeconds:    number
 *   detectedAt:   ISO date string (for the formatted label)
 *   likelyStep?:  step name (e.g. 'detect') — appended when present
 *   traceUrl?:    string — link target for the right-side button
 *   onOpenTrace?: callback alternative to traceUrl
 */

import styles from './RegressionCallout.module.css';

const SERVICE_LABELS = {
  merovingian: 'Merovingian',
  sati: 'Sati',
  sentinel: 'Sentinel',
  seraph: 'Seraph',
  archivist: 'Archivist',
};

function formatDateShort(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }).toLowerCase();
}

export default function RegressionCallout({
  service,
  fromSeconds,
  toSeconds,
  detectedAt,
  likelyStep,
  traceUrl,
  onOpenTrace,
}) {
  const label = SERVICE_LABELS[service] || service;
  return (
    <div className={styles.callout} role="alert">
      <span className={styles.tag}>! REGRESSION</span>
      <span className={styles.body}>
        <strong>{label}</strong> avg jumped from{' '}
        <span className={styles.number}>{fromSeconds.toFixed(2)}s</span> →{' '}
        <span className={styles.numberHi}>{toSeconds.toFixed(2)}s</span>
        {detectedAt && (
          <>
            {' '}on{' '}
            <span className={styles.mono}>{formatDateShort(detectedAt)}</span>
          </>
        )}
        {likelyStep && (
          <>
            . Likely culprit: <span className={styles.mono}>{likelyStep}</span> step.
          </>
        )}
      </span>
      <span className={styles.spacer} />
      {(traceUrl || onOpenTrace) && (
        <button
          type="button"
          className={styles.openBtn}
          onClick={() => {
            if (onOpenTrace) onOpenTrace();
            else if (traceUrl) window.location.href = traceUrl;
          }}
        >
          Open trace
        </button>
      )}
    </div>
  );
}
